const config = {
    emailService:'service_wf7hryt',
    emailTemplate:'template_jp5426s',
    apiKey:'y_Rtz7Z7calkWQgIE',
    RECAPTCHA_API_KEY: '6LeweX4rAAAAANTMA0uXSRh9cCGfka8VI830eyi3'
}

export default config;